<template>
  <div>
    <v-card-text class="card-text pt-5 pb-1">
      <v-form 
        ref="form"
        @keyup.native.enter="submit"
      >
        <v-text-field
          autofocus
          v-model="email"
          label="Email *"
          :error-messages="emailErrorMessages"
          validate-on-blur
          :rules="[required, validEmail]"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Mật khẩu *"
          :error-messages="passwordErrorMessages"
          :type="passwordShow ? 'text' : 'password'"
          :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordShow = !passwordShow"
          validate-on-blur
          :rules="[required]"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-progress-circular
        v-show="loading"
        indeterminate
        color="primary"
        size="24"
        width="3"
        class="mr-2"
      ></v-progress-circular>
      <v-btn
        color="primary"
        text
        class="mr-2"
        @click="submit"
      >Đăng nhập</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import LoginMixin from './LoginMixin.js'

export default {
  name: 'SignInForm',

  data: () => ({
    loading: false,

    email: '',
    password: '',

    emailErrorMessages: [],
    passwordErrorMessages: [],

    passwordShow: false,

    required: v => v !== '' || 'Thông tin bắt buộc.',
    validEmail: v => /.+@.+\..+/.test(v) || 'Email không hợp lệ.',
  }),

  mixins: [
    LoginMixin,
  ],

  methods: {
    async submit () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      await this.login()
      this.loading = false
    },
  }
}
</script>

<style scoped>

</style>
